export default {spreads:{Principal:{}},typenameResolver:'PartyTypenameResolver'}